<template>
  <div class="factory__card" @click="setfeaturedfactory(factoryid)">
    <div>{{factory.business_name}}</div>
  </div>
</template>

<script>
import {store} from '@/store'
export default {
  name: 'FactoryCard',
  props: {
    factoryid: String
  },
  computed: {
    factory: function(){
      return store.state.factories.find(f=> f.id === this.factoryid)
    }
  },
  methods: {
    setfeaturedfactory: function(id) {
      store.dispatch('setFactory', id)
      store.dispatch('setRepGroup')
    }
  }
}
</script>

<style scoped lang="less">

.shadow {
  box-shadow: 0px 2px 12px 0px rgba(0,0,0,0.25);
}
.factory__card {
  display: block;
  padding: 12px;
  background-color: white;
  box-sizing: border-box;
  border-radius: 3px;
  margin: 6px;
  cursor: pointer;
  &:extend(.shadow);
}
</style>



// WEBPACK FOOTER //
// src/components/mainpage/FactoryCard.vue